import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import {getResultLevelRanges} from '../../nuralogix/resultLevels';

/**
 * MulticolorSlider component for rendering a multicolored slider based on result levels.
 *
 * @component
 * @param {Object} props - The properties of the component.
 * @param {number} props.result - The result value to determine the color of the slider.
 * @param {string} props.metricName - The name of the metric associated with the result.
 * @returns {JSX.Element} The MulticolorSlider component.
 */
const MulticolorSlider = ({result, metricName}) => {
  const {nuralogixLevel, colourCircleSlider, colourLineRanges, circlePosition} = getResultLevelRanges(
    result,
    metricName,
    true,
  );

  const colorStopsForCircle = {
    offset: `${result}%`,
    color: colourCircleSlider,
    tooltip: nuralogixLevel,
  };

  return (
    <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" viewBox="-2 0 100 1">
      <linearGradient id="sliderBackground" x1="0%" y1="0%" x2="100%" y2="0%">
        {colourLineRanges.map((stop, index) => (
          <stop key={index} offset={stop.offset} stopColor={stop.color} data-title={stop.tooltip} />
        ))}
      </linearGradient>
      <rect width="100%" height="100%" fill="url(#sliderBackground)" rx="0.5" ry="0.5" />
      <Tooltip
        title={
          <Typography>
            {colorStopsForCircle.tooltip.split('\n').map((line, i) => (
              <div key={i}>{line}</div>
            ))}
          </Typography>
        }
        placement="top"
      >
        <circle cx={`${circlePosition}`} cy="70%" r="1.2" fill={colorStopsForCircle.color} />
      </Tooltip>
    </svg>
  );
};

export default MulticolorSlider;
